import { REACT_QUERY_KEYS } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { useQuery } from '@tanstack/react-query';
import { container } from '../../DataDomain';
import { IChannelService } from '../../application/services/ChannelService';
import { log } from '@intigral/utils';
import { IGetChannelsParams } from '../../entity/interface/iChannels';

export const useChannelListQuery = (searchParams: IGetChannelsParams, rating: string) =>
    useQuery({
        queryKey: [REACT_QUERY_KEYS.CHANNEL_LIST, rating],
        staleTime: 60 * 60 * 1000,
        enabled: true,
        queryFn: async () => {
            const channelService = container.resolve<IChannelService>(DI.SERVICES.IChannelService);
            const response = await channelService.getAllChannels(searchParams).catch((_error) => {
                log.error(_error);
                return [];
            });
            return response;
        },
    });
